import { call } from '@advanza/api'
import { Button } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import { useAppDispatch } from 'hooks/hooks'
import { useState } from 'react'

interface ConfirmSendWhatsAppMessageModalProps {
    invoiceId: number
}

const ConfirmSendWhatsAppMessageModal = NiceModal.create(
    ({ invoiceId }: ConfirmSendWhatsAppMessageModalProps) => {
        const modal = useModal()
        const [isSending, setIsSending] = useState(false)
        const dispatch = useAppDispatch()

        function onConfirm() {
            setIsSending(true)
            call(`office/invoices/send-whatsapp-message/${invoiceId}`)
                .then(() => {
                    modal.resolve()
                    modal.hide()
                    dispatch({ type: 'INVALIDATE_INVOICES' })
                })
                .finally(() => setIsSending(false))
        }
        return (
            <BaseModal>
                <BaseModalMainContent>
                    Are you sure you want to send this message?
                </BaseModalMainContent>
                <BaseModalFooter>
                    <Button
                        disabled={isSending}
                        style={{ float: 'left' }}
                        onClick={() => {
                            modal.resolve()
                            modal.hide()
                        }}
                        appearance={'secondary'}>
                        Cancel
                    </Button>
                    <Button
                        disabled={isSending}
                        style={{ float: 'right' }}
                        onClick={() => onConfirm()}
                        appearance={'primary'}>
                        Confirm
                    </Button>
                </BaseModalFooter>
            </BaseModal>
        )
    },
)

export default ConfirmSendWhatsAppMessageModal
